import { ReactWrapper } from '@components'
import { TranslationDropdown } from './TranslationDropdown'

export const translationDropdownComponent = ReactWrapper(
  TranslationDropdown,
  'translationDropdown',
)
